<template>
  <div id="__nuxt" style="height: auto !important">
    <!--[-->
    <div class="pc record___en" data-v-79cdd511="" style="height: auto !important">
      <HeadTop></HeadTop>
      <!-- 头部 -->
      <div class="n-config-provider" style="height: auto !important">
        <div class="page-a">
          <div data-v-a1201187="" class="record-a pc_container">
            <div data-v-05cd39fb="" data-v-a1201187="" class="userinfo">
              <div data-v-05cd39fb="" class="info">
                <img data-v-05cd39fb="" crossorigin="anonymous" referrer="no-referrer" src="../../static/xm.png" alt="hlin A" class="avatar" />
                <div data-v-05cd39fb="" class="middle">
                  <p data-v-05cd39fb="" class="name">{{ info.email }}</p>
                  <p data-v-05cd39fb="" class="uid -google">ID:{{ info.uid }}</p>
                </div>
                <!-- <button data-v-05cd39fb="" class="signin">{{ $t('_m._tcdl') }}</button> -->
              </div>
              <!---->
              <div style="display: flex; justify-content: space-between">
                <div data-v-05cd39fb="" class="topup">
                  <div data-v-05cd39fb="" class="coins wdtkuandu">
                    <span data-v-05cd39fb="" class="number">${{ wallet.balance }}</span>
                    <div data-v-05cd39fb="" class="coins-logo">
                      <div data-v-05cd39fb="" class="logo oss-image-wrapper logo xx2"></div>
                      <span data-v-05cd39fb="" class="text">{{ $t('_h._ye') }}</span>
                    </div>
                  </div>
                  <div data-v-05cd39fb="" class="bonus wdtkuandu">
                    <span data-v-05cd39fb="" class="number">${{ wallet.freeze }}</span>
                    <div data-v-05cd39fb="" class="bonus-logo">
                      <div data-v-05cd39fb="" class="logo oss-image-wrapper logo xx3"></div>
                      <span data-v-05cd39fb="" class="text">{{ $t('_h._dj') }}</span>
                    </div>
                  </div>
                  <button data-v-05cd39fb="" class="topup_btn column" @click="onDeposit">{{ $t('_m._cb') }}</button>
                  <button data-v-05cd39fb="" class="topup_btn column yhzz" @click="onBank" v-if="info.is_bank == 2">{{ $t('_m._yhzz') }}</button>
                  <button data-v-05cd39fb="" class="topup_btn column setqe" @click="onWithdrawal">{{ $t('_m._tb') }}</button>
                </div>

                <div data-v-05cd39fb="" class="topup">
                  <div data-v-05cd39fb="" class="coins wdtkuandu">
                    <span data-v-05cd39fb="" class="number">${{ wallet.video }}</span>
                    <div data-v-05cd39fb="" class="coins-logo">
                      <div data-v-05cd39fb="" class="logo oss-image-wrapper logo xx2"></div>
                      <span data-v-05cd39fb="" class="text">{{ $t('_sp._dbye') }}</span>
                    </div>
                  </div>
                  <button data-v-05cd39fb="" class="topup_btn column" style="background: #ffc107" @click="onTransfer">{{ $t('_sp.hzye') }}</button>
                </div>
              </div>
              <div data-v-05cd39fb="" class="line"></div>
            </div>

            <!-- 我的历史 -->
            <router-view></router-view>
            <!-- 我的历史 结束 -->
          </div>
        </div>
      </div>
      <!--]--><!---->
    </div>
    <!----><!----><!---->
    <div class="loading isPc" style="display: none" data-v-b4f76b67="">
      <img src="../../static/img/loading.Czr7mSn8.png" style="" data-v-b4f76b67="" />
    </div>
    <div data-v-4a14e8e9="" class="toast isPc" style="display: none">
      <div data-v-4a14e8e9="" class="toast_wrap">
        <img
          data-v-4a14e8e9=""
          src="data:image/png;base64,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"
          class="icon"
        />
        <div data-v-4a14e8e9="" class="msg_content_wrapper">
          <span data-v-4a14e8e9="" class="msg_content"></span>
        </div>
      </div>
    </div>
    <!--]-->
  </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'
export default {
  name: 'videoVue',
  components: {
    HeadTop
  },
  data() {
    return {
      wallet: {},
      info: {
        is_bank: 1
      }
    }
  },
  created() {
    this.getWallet()
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.info = this.$common.getInfo()
    },
    getWallet() {
      var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        hide()
        if (res.data.length <= 0) {
          that.$message.error('error')
          return
        }
        that.wallet = res.data
      })
    },
    onDeposit() {
      this.$router.push({ name: 'deposit' })
    },
    onTransfer() {
      this.$router.push({ name: 'transfer' })
    },
    onBank() {
      this.$router.push({ name: 'bank' })
    },
    onWithdrawal() {
      this.$router.push({ name: 'withdraw' })
    }
  }
}
</script>
<style scoped>
@import url('../../static/css_record/index.DLn5QGB4.css');
</style>
<style scoped>
.setqe {
background: #232323 !important;
    color: #fff !important;
  /* border: 1px solid #fb3867 !important; */
}
.xx2 {
  background: url('../../static/img/coins.png') center top / 100% no-repeat;
}
.xx3 {
  background: url('../../static/img/bonus.png') center top / 100% no-repeat;
}
</style>
